// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2mk_2","boxTitle":"Qualiphy_boxTitle__3R4yi","box":"Qualiphy_box__t9QHy","toggleWrap":"Qualiphy_toggleWrap__1peX4"};